import { useTheme } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import TimeChipSelector from "components/TimeChipSelector";

export const StyledTimeChipSelector = ({
  width,
  showEditGeneral,
  label,
  timeList,
  max,
  isIndent,
  onAddTimeChip,
  onDeleteTimeChip,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        mt: 3.5,
        ml: isIndent ? 2.5 : 1,
        color: theme.palette.primary.main,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.customFontSize[5],
        fontWeight: theme.typography.customFontWeight[3],
      }}
    >
      <Typography
        sx={{
          width: width,
          color: theme.palette.primary.greyPrimary,
          fontSize: theme.typography.customFontSize[2],
          fontWeight: theme.typography.customFontWeight[0],
          fontFamily: theme.typography.fontFamily,
          mt: "3px",
          mr: "10px",
        }}
      >
        {label}
      </Typography>

      <TimeChipSelector
        timeList={timeList}
        max={max}
        onAddTimeChip={onAddTimeChip}
        onDeleteTimeChip={onDeleteTimeChip}
      />
    </Box>
  );
};